import React, { useState, useEffect } from "react";
import EditIcon from "@mui/icons-material/Edit";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import { primaryColor } from "assets/jss/material-dashboard-pro-react";
import Button from "components/CustomButtons/Button";
import HTMLEditor from "components/HTMLEditor/HTMLEditor";
import AntDDataGrid from "components/DataGrid/AntDDataGrid";
import styles from "../ReportStyles.module.css";
import CloseIcon from "@mui/icons-material/Close";
import { updateReportBody } from "../reportUtils";

const LibraryServices = ({ data, report, setReportBody }) => {
  const [valueContent, setValueContent] = useState(data.description ?? "");

  const handleChangeDescription = (content) => {
    setValueContent(content);
    updateReportBody(
      setReportBody,
      "CRITERION7_FACILITIES",
      "LibraryServices",
      "description",
      content
    );
  };

  return (
    <>
      <h3>FACILITIES: Library Services</h3>

      <p className={styles.reportParagraphTitle}>
        The following is a description and evaluation of the capability of the
        library (or libraries) to serve the program including:
      </p>
      <ul>
        <li>
          The adequacy of the library’s technical collection relative to the
          needs of the program and the faculty,
        </li>
        <li>
          The adequacy of the process by which faculty may request the library
          to order books or subscriptions,
        </li>
        <li>
          The library’s systems for locating and obtaining electronic
          information,
        </li>
        <li>
          And any other library services relevant to the needs of the program.
        </li>
      </ul>

      <HTMLEditor
        valueContent={valueContent}
        setValueContent={handleChangeDescription}
      />

      <br />
      <p className={styles.reportParagraphTitle}>
        The following is the list of the library services or resources initially
        defined for the program's courses:
      </p>

      <ul>
        {data?.libraryServices?.map(
          (resource, index) => (
            <li key={resource.id}>{resource.resource}</li>
          )
        )}
      </ul>
    </>
  );
};

export default LibraryServices;
